import { LifeArea, Locales, LocalizedLifeArea } from '@griply/types';

import { getLocalizedStringValue } from './get-localized-string-value';
import { normalizeForSearch } from './normalize-for-search';

export const filterLifeAreasBySearchText = (
  lifeAreas: (LifeArea | LocalizedLifeArea)[],
  searchText: string,
  locale: Locales,
): (LifeArea | LocalizedLifeArea)[] => {
  if (!searchText) {
    return [];
  }
  const normalizedSearchText = normalizeForSearch(searchText.trim());

  return lifeAreas
    .filter(({ name }) =>
      normalizeForSearch(getLocalizedStringValue(name, locale)).includes(
        normalizedSearchText,
      ),
    )
    .sort((a, b) =>
      getLocalizedStringValue(a.name, locale).localeCompare(
        getLocalizedStringValue(b.name, locale),
      ),
    );
};
